module.exports = __webpack_public_path__ + "img/sunbingbing.5e0d2847.jpg";